export const Filter = {
  ProjectName: "projectName" as const,
  Period: "period" as const,
  CustomerId: "customerId" as const,
  CustomerName: "customerName" as const,
  ProjectMemberId: "projectMemberId" as const,
  ProjectMemberName: "projectMemberName" as const,
  BusinessUnitId: "businessUnitId" as const,
  BusinessUnitName: "businessUnitName" as const,
  OnlyWithLeftToInvoice: "onlyWithLeftToInvoice" as const,
  IncludeDeletedProjects: "includeDeletedProjects" as const,
  IncludeInactiveProjects: "includeInactiveProjects" as const,
}

export const Create = {
  ProjectName: "projectName" as const,
  ProjectDescription: "projectDescription" as const,
  ProjectStartDate: "projectStartDate" as const,
  ProjectEndDate: "projectEndDate" as const,
  CustomerId: "customerId" as const,
  CustomerName: "customerName" as const,
  InvoiceReferenceId: "invoiceReferenceId" as const,
  InvoiceReferenceName: "invoiceReferenceName" as const,
  ProjectManagerId: "projectManagerId" as const,
  ProjectManagerName: "projectManagerName" as const,
  IsAutoInvoicing: "isAutoInvoicing" as const,
  IsBundledInvoice: "isBundledInvoice" as const,
  InvoicingIntervalName: "invoicingIntervalName" as const,
  InvoicingInterval: "invoicingInterval" as const,
  IncludeCommentsOnAttachments: "includeCommentsOnAttachments" as const,
  IncludeAttachmentsOnInvoice: "includeAttachmentsOnInvoice" as const,
  Currency: "currency" as const,
  InvoiceTimeReportDetailLevelName: "invoiceTimeReportDetailLevelName" as const,
  InvoiceTimeReportDetailLevel: "invoiceTimeReportDetailLevel" as const,
  IsDescriptionMandatory: "isDescriptionMandatory" as const,
  PeriodisationEnabled: "periodisationEnabled" as const,
  ProjectMembers: "projectMembers" as const,
  ProjectCategories: "projectCategories" as const,
  IsInternalProject: "isInternalProject" as const,
  LoadingCustomer: "loadingCustomer" as const,
  DimensionReadonly: "dimensionReadonly" as const,
  HasSellerDimensionInInvoice: "hasSellerDimensionInInvoice" as const,
  ProjectCategoryMembers: "projectCategoryMembers" as const,
  SelfBillingMissingHint: "selfBillingMissingHint" as const,
}

export const Update = {
  Id: "id" as const,
}

export const ProjectData = {
  Rows: "rows" as const,
}

export const ProjectMember = {
  IsNew: "isNew" as const,
  Id: "id" as const,
  Name: "name" as const,
  StartDate: "startDate" as const,
  EndDate: "endDate" as const,
  IsTimeReportingActive: "isTimeReportingActive" as const,
  Categories: "categories" as const,
  CategoryRates: "categoryRates" as const,
  FutureCategoryRates: "futureCategoryRates" as const,
  ChangesApplyFrom: "changesApplyFrom" as const,
  SelfBillingEnabled: "selfBillingEnabled" as const,
  SelfBillingOrgNumber: "selfBillingOrgNumber" as const,
  SelfBillingEmail: "selfBillingEmail" as const,
  SelfBillingPaymentMethod: "selfBillingPaymentMethod" as const,
  SelfBillingBankgiro: "selfBillingBankgiro" as const,
  SelfBillingPlusgiro: "selfBillingPlusgiro" as const,
  SelfBillingClearingNumber: "selfBillingClearingNumber" as const,
  SelfBillingAccountNumber: "selfBillingAccountNumber" as const,
  SelfBillingIBAN: "selfBillingIBAN" as const,
  SelfBillingPaymentTerms: "selfBillingPaymentTerms" as const,
  SelfBillingCalculationMethod: "selfBillingCalculationMethod" as const,
  SelfBillingPercentage: "selfBillingPercentage" as const,
  SelfBillingHourlyRates: "selfBillingHourlyRates" as const,
  SelfBillingAllHourlyRates: "selfBillingAllHourlyRates" as const,
  Yet: "yet" as const,
  SelfBillingFutureRates: "selfBillingFutureRates" as const,
  Transient: "Transient" as const,
  SelfBillingChangesApplyFrom: "selfBillingChangesApplyFrom" as const,
  SelfBillingMonthlyCost: "selfBillingMonthlyCost" as const,
}

export const ExtendedProjectMember = {
  IndividualBillingModel: "individualBillingModel" as const,
  IndividualBillingModelName: "individualBillingModelName" as const,
  HourlyRate: "hourlyRate" as const,
  Hours: "hours" as const,
  CurrentRate: "currentRate" as const,
}

export const CategoryMember = {
  Selected: "selected" as const,
  AccessUntil: "accessUntil" as const,
  HasRates: "hasRates" as const,
}

export const MemberRate = {
  Selected: "selected" as const,
}

export const FutureMemberRate = {
  HourlyRateId: "hourlyRateId" as const,
  SoftDeleted: "softDeleted" as const,
  ValidFrom: "validFrom" as const,
}

export const ProjectCategory = {
  IsNew: "isNew" as const,
  Id: "id" as const,
  Name: "name" as const,
  IsDefault: "isDefault" as const,
  BillingModel: "billingModel" as const,
  DefaultHourlyRate: "defaultHourlyRate" as const,
  CategoryMembers: "categoryMembers" as const,
  MemberRates: "memberRates" as const,
  FutureMemberRates: "futureMemberRates" as const,
  IsCatgoryActive: "isCatgoryActive" as const,
  ChangesApplyFrom: "changesApplyFrom" as const,
  EndDate: "endDate" as const,
  ShouldEffectSalaryPayout: "shouldEffectSalaryPayout" as const,
  ConnectedDeviationType: "connectedDeviationType" as const,
  ConnectedDeviationTypeName: "connectedDeviationTypeName" as const,
  DeviationComment: "deviationComment" as const,
  CustomDeviationName: "customDeviationName" as const,
  AdjustPreviouslyReportedTime: "adjustPreviouslyReportedTime" as const,
}

export const CategoryRate = {
}

export const SelfBillingRate = {
  Id: "id" as const,
  TimeReportingProjectCategoryId: "timeReportingProjectCategoryId" as const,
  CategoryName: "categoryName" as const,
  Amount: "amount" as const,
  FromDate: "fromDate" as const,
  IsCurrent: "isCurrent" as const,
  Only: "only" as const,
  RowKey: "rowKey" as const,
}

export const ConnectInvoice = {
  InvoiceList: "invoiceList" as const,
  InvoiceListSuggestions: "invoiceListSuggestions" as const,
  SelectedItems: "selectedItems" as const,
  Loading: "loading" as const,
  InvoiceAmount: "invoiceAmount" as const,
  Currency: "currency" as const,
}

export const ConnectInvoiceMemberCategory = {
  CategoryId: "categoryId" as const,
  MemberId: "memberId" as const,
  CategoryName: "categoryName" as const,
  MemberName: "memberName" as const,
  Amount: "amount" as const,
}

export const ConnectInvoiceCategory = {
  CategoryId: "categoryId" as const,
  CategoryName: "categoryName" as const,
  Icon: "icon" as const,
  Amount: "amount" as const,
}

